import { Events, type FantasyEvents, type PodEvents } from '@app/client/common/structs/events/events';
import config from '@app/config';
import { track } from '@app/helpers';

declare global {
    interface Window {
        fbq; // Facebook
        rdt; // Reddit
    }
}

export const registerEvent = (
    eventName: Events | PodEvents | FantasyEvents,
    properties: Record<string, string | number | null> = {},
) => {
    if (config.nodeEnv === 'development') {
        console.debug(`> [ Event Triggered ]: "${eventName}"`, properties); // eslint-disable-line no-console
    }

    // Execute global actions
    track(eventName, {
        utm_campaign: null,
        utm_source: null,
        utm_medium: null,
        ...properties,
    });

    // Execute custom actions
    switch (eventName) {
        case Events.checkout_page_viewed:
            window.rdt('track', 'ViewContent');
            window.fbq('track', 'InitiateCheckout');
            break;
        case Events.emoji_search_executed:
            window.rdt('track', 'Search');
            window.fbq('track', 'Search');
            break;
        case Events.landing_page_viewed:
            break;
        case Events.purchased:
            window.rdt('track', 'Purchase');
            window.fbq('track', 'Purchase', { value: properties.price, currency: 'USD' });
            break;
        case Events.user_signup:
            window.rdt('track', 'SignUp');
            break;
        case Events.yat_link_redirect:
            break;
        case Events.yat_minted:
            break;
    }
};

export const registerEverflowClick = (EF) => {
    EF.click({
        offer_id: EF.urlParameter('oid'),
        affiliate_id: EF.urlParameter('affid'),
        sub1: EF.urlParameter('sub1'),
        sub2: EF.urlParameter('sub2'),
        sub3: EF.urlParameter('sub3'),
        sub4: EF.urlParameter('sub4'),
        sub5: EF.urlParameter('sub5'),
        uid: EF.urlParameter('uid'),
        source_id: EF.urlParameter('source_id'),
        transaction_id: EF.urlParameter('_ef_transaction_id'),
    });
};
